import { render, staticRenderFns } from "./WidgetLayout.vue?vue&type=template&id=2ce5e7be"
import script from "./WidgetLayout.vue?vue&type=script&lang=js"
export * from "./WidgetLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports